import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { IEncounter, IMedia } from "../studies/studiesSlice";
import { Divider } from "@mui/material";
import DisplayText from "../../components/DisplayText/DisplayText";
import { Box } from "@mui/system";
import { getMimeTypePrettyName } from "../../utils/MediaUtils";
import MediaThumbnail from "../../components/MediaThumbnail";

interface IAddStudyDialogProps {
    onClose: () => void;
    onAddStudy: (studyId: string) => void;
    open: boolean;
    encounters: IEncounter[];
}

const AddStudyDialog: React.FC<IAddStudyDialogProps> = ({ onClose, open, encounters, onAddStudy }) => {
    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = (value: string) => {
        onAddStudy(value);
    };

    const renderStudy = (media: IMedia) => (
        <ListItem
            sx={{ pl: 0, display: "flex", alignItems: "center", gap: 5 }}
            button
            onClick={() => handleListItemClick(media.uuid)}
            key={media.uuid}
        >
            <Box
                sx={{
                    marginRight: 5,
                    borderRadius: "15px",
                    border: "2px solid #3a414e",
                    overflow: "hidden",
                    height: 160,
                    width: 160,
                }}
            >
                <MediaThumbnail media={media} size="160px" onClick={() => handleListItemClick(media.uuid)} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <DisplayText
                    text={`${getMimeTypePrettyName(media.mimeType)} ${media.laterality ? `- ${media.laterality}` : ""}`}
                    type="bodySmall"
                    variant="regular"
                />
                <DisplayText
                    text={`Slices: ${media.dicomData.numberOfFrames ?? "-"}`}
                    type="bodyXSmall"
                    variant="regular"
                />
            </Box>
        </ListItem>
    );

    const renderVisit = (encounter: IEncounter) => {
        // Check if encounter has any media items
        const hasMedia = encounter.studies.some((study) => study.series.some((serie) => serie.medias.length > 0));

        return (
            <Box key={encounter.uuid}>
                <Divider />
                <li style={{ paddingLeft: 25, paddingRight: 25, marginBottom: 12 }} key={encounter.uuid}>
                    <ul>
                        <DisplayText
                            text={`${encounter.visitName} - ${new Date(encounter.encounterDate).toLocaleDateString()}`}
                            type="bodyMedium"
                            variant="regular"
                            style={{ marginTop: 12, marginBottom: 4 }}
                        />

                        {hasMedia ? (
                            encounter.studies.map((study) =>
                                study.series.map((serie) => serie.medias.map((media) => renderStudy(media)))
                            )
                        ) : (
                            <DisplayText
                                text="No media"
                                type="bodyMedium"
                                variant="regular"
                                style={{ marginTop: 24, marginBottom: 24, textAlign: "center" }}
                            />
                        )}
                    </ul>
                </li>
            </Box>
        );
    };

    return (
        <Dialog fullWidth maxWidth="sm" scroll="paper" onClose={handleClose} open={open}>
            <DialogTitle>Add Study</DialogTitle>
            <List subheader={<li />}>{encounters.map(renderVisit)}</List>
        </Dialog>
    );
};

export default AddStudyDialog;
